import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/used_close_black.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3ba43997")

_pushScopeId("data-v-3ba43997")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-display-area" }
const _hoisted_3 = { class: "dialog-box" }
const _hoisted_4 = { class: "dialog-box-contents" }
const _hoisted_5 = { class: "dialog-box-contents-contents" }
const _hoisted_6 = { class: "dialog-box-contents-contents-text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "dialog-box-close-image",
  src: _imports_0
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.displayText), 1)
                ])
              ]),
              _createVNode("div", {
                class: "dialog-box-close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAction(...args)))
              }, [
                _hoisted_7
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isShowDialog]
        ])
      ]),
      _: 1
    })
  ]))
})